import { render, staticRenderFns } from "./EditBasicRecord.vue?vue&type=template&id=30edf58a&"
import script from "./EditBasicRecord.vue?vue&type=script&lang=js&"
export * from "./EditBasicRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports